<div style="padding: 24px; max-width: 1400px; margin: 0 auto;" *ngIf="salesOrder">

  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
    <div>
      <button mat-icon-button (click)="goBack()" matTooltip="Back to list"><mat-icon>arrow_back</mat-icon></button>
      <span style="font-size: 20px; font-weight: 500;">
        Sales Order #{{salesOrder.id}} &mdash; Trip {{salesOrder.tripId}}
      </span>
      <span *ngIf="salesOrder.isCancelled" style="color: red; margin-left: 8px;">[CANCELLED]</span>
      <span *ngIf="salesOrder.isFamTrip" style="color: #1976d2; margin-left: 8px;">[FAM]</span>
    </div>
    <div style="display: flex; gap: 8px; flex-wrap: wrap;">
      <button mat-raised-button color="primary" (click)="triggerSync()">Trigger Sync</button>
      <button mat-raised-button color="accent" (click)="startTrip()">Start Trip</button>
      <button mat-stroked-button (click)="markFam()"
        [matTooltip]="salesOrder.isFamTrip ? 'Clear FAM flag (will allow payments again)' : 'Mark as FAM (no-payment scenario)'">
        {{salesOrder.isFamTrip ? 'Unmark FAM' : 'Mark FAM'}}
      </button>
      <button mat-raised-button color="warn" (click)="cancelTrip()">Cancel Trip</button>
    </div>
  </div>

  <!-- Header Form -->
  <mat-card style="margin-bottom: 16px;">
    <mat-card-header><mat-card-title>Header</mat-card-title></mat-card-header>
    <mat-card-content>
      <form [formGroup]="headerForm" style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; padding-top: 12px;">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Trip Reference</mat-label>
          <input matInput formControlName="tripReference">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Booked Date</mat-label>
          <input matInput [matDatepicker]="bookedPicker" formControlName="bookedDate">
          <mat-datepicker-toggle matIconSuffix [for]="bookedPicker"></mat-datepicker-toggle>
          <mat-datepicker #bookedPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Trip Start Date</mat-label>
          <input matInput [matDatepicker]="tripStartPicker" formControlName="tripStartDate">
          <mat-datepicker-toggle matIconSuffix [for]="tripStartPicker"></mat-datepicker-toggle>
          <mat-datepicker #tripStartPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Number of Days</mat-label>
          <input matInput type="number" formControlName="numberOfDays">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Main Client</mat-label>
          <input matInput [formControl]="clientControl" [matAutocomplete]="clientAuto" placeholder="Type to search...">
          <mat-autocomplete #clientAuto="matAutocomplete" [displayWith]="displayClient" (optionSelected)="onClientSelected($event.option.value)">
            <mat-option *ngFor="let c of filteredClients | async" [value]="c">
              {{c.name}} ({{c.email || ''}})
            </mat-option>
          </mat-autocomplete>
          <mat-hint>Name: {{headerForm.get('mainClientName')?.value}} | Email: {{headerForm.get('mainClientEmail')?.value}}</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Client Email</mat-label>
          <input matInput formControlName="mainClientEmail">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Quote Agent</mat-label>
          <mat-select formControlName="quoteAgentRefId">
            <mat-option [value]="null">-- None --</mat-option>
            <mat-option *ngFor="let agent of lookups?.quoteAgents" [value]="agent.id">
              {{agent.name}} ({{agent.quoteAgentId}})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div style="display: flex; align-items: center;">
          <mat-checkbox formControlName="isCancelled">Cancelled</mat-checkbox>
        </div>
        <div style="display: flex; align-items: center;">
          <button mat-raised-button color="primary" (click)="saveHeader()">Save Header</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Lines Table -->
  <mat-card style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>Services</mat-card-title>
      <span style="flex: 1;"></span>
      <button mat-mini-fab color="primary" (click)="addLine()" [disabled]="headerForm.dirty"
        [matTooltip]="headerForm.dirty ? 'Save header first' : 'Add Service'">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="serviceLines" style="width: 100%;">
        <ng-container matColumnDef="productType">
          <th mat-header-cell *matHeaderCellDef>Product Type</th>
          <td mat-cell *matCellDef="let row">{{getProductTypeName(row.productTypeId)}}</td>
        </ng-container>
        <ng-container matColumnDef="serviceName">
          <th mat-header-cell *matHeaderCellDef>Service</th>
          <td mat-cell *matCellDef="let row">{{row.serviceName}}</td>
        </ng-container>
        <ng-container matColumnDef="vendorName">
          <th mat-header-cell *matHeaderCellDef>Vendor</th>
          <td mat-cell *matCellDef="let row">{{row.vendorName}}</td>
        </ng-container>
        <ng-container matColumnDef="cost">
          <th mat-header-cell *matHeaderCellDef>Cost</th>
          <td mat-cell *matCellDef="let row">{{row.actualCost | number:'1.2-2'}}</td>
        </ng-container>
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Price</th>
          <td mat-cell *matCellDef="let row">{{row.quotedCost | number:'1.2-2'}}</td>
        </ng-container>
        <ng-container matColumnDef="agentCommission">
          <th mat-header-cell *matHeaderCellDef>Commission</th>
          <td mat-cell *matCellDef="let row">{{getAgentCommission(row) | number:'1.2-2'}}</td>
        </ng-container>
        <ng-container matColumnDef="currencyCode">
          <th mat-header-cell *matHeaderCellDef>Currency</th>
          <td mat-cell *matCellDef="let row">{{row.currencyCode}}</td>
        </ng-container>
        <ng-container matColumnDef="totalUnits">
          <th mat-header-cell *matHeaderCellDef>Units</th>
          <td mat-cell *matCellDef="let row">{{row.totalUnits}}</td>
        </ng-container>
        <ng-container matColumnDef="serviceStartDate">
          <th mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let row">{{row.serviceStartDate | date:'shortDate'}}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button (click)="editLine(row)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button color="warn" (click)="deleteLine(row)" matTooltip="Delete"><mat-icon>delete</mat-icon></button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="lineColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: lineColumns;"></tr>
      </table>
    </mat-card-content>
  </mat-card>

  <!-- Payments Table -->
  <mat-card style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>Traveler Payments</mat-card-title>
      <span style="flex: 1;"></span>
      <button mat-mini-fab color="primary" (click)="addPayment()" matTooltip="Add Payment">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="salesOrder.salesOrderTravelerPayments || []" style="width: 100%;">
        <ng-container matColumnDef="travelerName">
          <th mat-header-cell *matHeaderCellDef>Traveler</th>
          <td mat-cell *matCellDef="let row">{{row.travelerName}}</td>
        </ng-container>
        <ng-container matColumnDef="productType">
          <th mat-header-cell *matHeaderCellDef>Product Type</th>
          <td mat-cell *matCellDef="let row">{{getProductTypeName(row.productTypeId)}}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let row">{{row.amount | number:'1.2-2'}}</td>
        </ng-container>
        <ng-container matColumnDef="currencyCode">
          <th mat-header-cell *matHeaderCellDef>Currency</th>
          <td mat-cell *matCellDef="let row">{{row.currencyCode}}</td>
        </ng-container>
        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef>Payment Date</th>
          <td mat-cell *matCellDef="let row">{{row.paymentDate | date:'shortDate'}}</td>
        </ng-container>
        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef>Reference</th>
          <td mat-cell *matCellDef="let row">{{row.reference}}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button color="warn" (click)="deletePayment(row)" matTooltip="Delete"><mat-icon>delete</mat-icon></button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="paymentColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: paymentColumns;"></tr>
      </table>
      <p style="color: #666; font-size: 12px; margin-top: 8px;">
        Tip: enter a negative <em>Amount</em> to seed a refund scenario (e.g. -250).
        Multi-currency: change the Currency field per row to test cross-currency D365 routing.
      </p>
    </mat-card-content>
  </mat-card>

  <!-- Travelers (address fields live on each traveler row) -->
  <mat-card style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>Travelers</mat-card-title>
      <span style="flex: 1;"></span>
      <button mat-mini-fab color="primary" (click)="addTraveler()" matTooltip="Add Traveler (drives ERP customer mapping)">
        <mat-icon>person_add</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="travelers" style="width: 100%;" *ngIf="travelers.length > 0; else noTravelers">
        <ng-container matColumnDef="travelerName">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">{{row.travelerName}}<span style="color:#888"> ({{row.travelerId}})</span></td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row">{{row.email}}</td>
        </ng-container>
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef>Phone</th>
          <td mat-cell *matCellDef="let row">{{row.phone || row.mobilePhone}}</td>
        </ng-container>
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Address</th>
          <td mat-cell *matCellDef="let row">{{travelerAddressLine(row)}}</td>
        </ng-container>
        <ng-container matColumnDef="mainContact">
          <th mat-header-cell *matHeaderCellDef>Main</th>
          <td mat-cell *matCellDef="let row">
            <mat-icon *ngIf="row.isMainContact" style="color:#1976d2;">check_circle</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button color="warn" (click)="deleteTraveler(row)" matTooltip="Remove"><mat-icon>delete</mat-icon></button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="travelerColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: travelerColumns;"></tr>
      </table>
      <ng-template #noTravelers>
        <p style="color: #888; padding: 8px 0;">No travelers yet. The ERP customer mapping pulls City / Country / Street / Postal from the <em>main-contact</em> traveler (or the first one).</p>
      </ng-template>
    </mat-card-content>
  </mat-card>


</div>
